import { render, staticRenderFns } from "./TheCallRecord.vue?vue&type=template&id=03e5ba5c&"
import script from "./TheCallRecord.vue?vue&type=script&lang=js&"
export * from "./TheCallRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports